import { useState } from 'react';

function useLoading() {
    const [isLoading, setIsLoading] = useState(false);

    const showLoading = (value) => {
        setIsLoading(value);
    };

    return { isLoading, showLoading };
}

export default useLoading;